var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-time-select',{attrs:{"placeholder":"选择时间"},model:{value:(_vm.current.value),callback:function ($$v) {_vm.$set(_vm.current, "value", $$v)},expression:"current.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }